(function($){

    var $body;
    var PlayerMinut = {

        $players : null,
        $cookie : null,
        timeResize : false,

        init : function(){

            this.$players = $( '.player-minut' );
            if( !this.$players.length ) return true;

            $body = $( 'body' );

            this.$cookie = $( '#ot-sdk-btn-floating' );

            // Configure each dropdown
            this.$players.each(function(){

                this.$ = this.$ || $( this );

                var data = this.$.data( 'PlayerMinut' );
                if( data !== undefined ) return true;
                data = {
                    _ : this,
                    $ : this.$,
                    $play : $( 'button[data-action="play"]', this.$ ),
                    $pause : $( 'button[data-action="pause"]', this.$ ),
                    $seek : $( '.percentage-bar span', this.$ ),
                    audio  : $( 'audio', this.$ ).get(0)
                };

                // Keep data
                this.$.data( 'PlayerMinut', data );

                // Play click
                data.$play.on( 'click', function(e){
                    e.preventDefault();
                    if( data.audio.paused ){

                        PlayerMinut.pauseOthers( data );
                        PlayerMinut.hideCookie();

                        data.audio.play();
                        data.$.addClass( 'playing' );
                    
                    }
                });
                data.$pause.on( 'click', function(e){
                    e.preventDefault();
                    data.audio.pause();
                    data.$.removeClass( 'playing' );
                });

                data.audio.addEventListener( 'ended', function(){
                    data.$.removeClass( 'playing after50' );
                    data.$seek.css( 'transform', '' );
                });

                data.audio.addEventListener( 'timeupdate', function(){

                    const newAngle = data.audio.currentTime * 360 / data.audio.duration;

                    if( newAngle > 180 ){
                        data.$.addClass( 'after50' );
                    }
                    else {
                        data.$.removeClass( 'after50' );
                    }

                    data.$seek.css( 'transform', 'rotate('+ newAngle +'deg)' );
                
                });

            });

        },

        hideCookie : function(){
            PlayerMinut.$cookie.css( 'transform', 'translateX(-100vw)' );
        },

        showCookie : function(){
            PlayerMinut.$cookie.css( 'transform', 'translateX(0)' );
        },

        pauseOthers : function( data ){

            this.$players.each(function(){

                const _data = this.$.data( 'PlayerMinut' );
                if( _data.audio.paused !== true ){
                    _data.audio.pause();
                    _data.$.removeClass( 'playing' );
                }

            });

        },

        isMobile : function(){
            return Utils.getPageWidth() <= 550;
        }

    };
    $(function(){ 
        PlayerMinut.init(); 
    });

})(jQuery);
